import CityPageTemplate from "../city-template/CityPageTemplate";
import { elPasoConfig } from "./data";

export default function ElPasoPage() {
  return <CityPageTemplate config={elPasoConfig} />;
}